'use client';

import { Button, Link as FreddyLink } from '@coolblue-development/freddy';
import buttonInteractionTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentInteraction/buttonInteractionTrigger';
import { ArrowRight } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { WorkArea } from '@graphQLTypes';
import { useTranslation } from '@i18n/useTranslation';
import Link from 'next/link';

import { ANALYTICS_DEPARTMENT_SUBFEATURES } from './constants';

type Props = {
  variant: 'button' | 'link';
  cardVariant: 'department' | 'culture';
  href: string;
  title: string;
  cardKey: WorkArea | 'culture';
};

export const CardLink = ({ variant, cardVariant, href, title, cardKey }: Props) => {
  const { t } = useTranslation('homePage.departmentCards');
  const { trackEvent } = useAnalytics();

  const linkText =
    cardVariant === 'department'
      ? t('departmentVacancies', { department: title })
      : t(`${cardKey}.moreAbout`);

  const onClick = () =>
    trackEvent(
      buttonInteractionTrigger({
        content: linkText,
        sub_feature: ANALYTICS_DEPARTMENT_SUBFEATURES[cardKey] as Parameters<
          typeof buttonInteractionTrigger
        >[0]['sub_feature']
      })
    );

  if (variant === 'button')
    return (
      <Button
        component={Link}
        variant='secondary'
        size='small'
        href={href}
        rel='noopener noreferrer'
        onClick={onClick}
        sx={{ visibility: 'hidden' }}
      >
        {linkText}
      </Button>
    );
  else
    return (
      <FreddyLink
        component={Link}
        startIcon={<ArrowRight />}
        href={href}
        rel='noopener noreferrer'
        onClick={onClick}
      >
        {linkText}
      </FreddyLink>
    );
};
